export default "__VITE_ASSET__379afa6a__"